<template>
  <div>
    <div class="maintainRatio">
      <b-row>
        <b-col class="text-center p-2">
          <div class="off bg-danger rounded d-inline-block p-2">
            {{ $t('MEETING.VIDEO_SPANNOVIDEO') }}
          </div>
        </b-col>
      </b-row>
      <b-row
        ref="allVideos"
        align-v="center"
        align-h="center"
        no-gutters
      >
        <div
          v-for="(participant,index) in participants"
          :key="index"
          :class="{ 'col-6 col-md-6': participants.length <= 4, 'col-12 col-md-12': participants.length <= 1, 'col-6 col-lg-4': participants.length > 4 && participants.length < 7, 'col-6 col-md-4': participants.length > 4 }"
          class="p-2 col-6"
        >
          <div class="rounded embed-responsive embed-responsive-16by9">
            <div class="rounded embed-responsive-item border noVideo">
              <div class="camera-off"><span>{{ participant.firstName }} {{ participant.lastName }}</span></div>
            </div>
          </div>
        </div>

      </b-row>
    </div>
  </div>
</template>
<script>
import AccountIcon from "icons/Account"
export default {
  name: 'NoVideos',
  components: {
   AccountIcon
  },
  props: {
    participants: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style>
.off{
 font-size: 14px;
}
.maintainRatio{
  width: calc((100vh - 165px) * (16/9));
  max-width: 100%;
  max-height: calc(100vh - 112px);
  margin: 0 auto;
}
.noVideo{
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: #bbbbbb;
}
@media (max-width: 768px) {
  .maintainRatio{
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VideoArea/NoVideos.vue